import { Link, useParams } from "react-router-dom";
import { TextMediumSM } from "../../../../Components/Text/MediumText";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { BackButton, CancelButton, CreateButton, DeleteButton, SubmitButton } from "../../../../Components/Utils/Buttons";
import { useEffect, useState } from "react";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import DataTable from "../../../../Components/Others/DataTable";
import MoreOptions from "../../../../Components/Utils/MoreOptions";
import UserCard from "./UserCard";
import List from "../../../../Components/Icons/list";
import Card from "../../../../Components/Icons/card";
import Pagination from "../../../../Components/Utils/Pagenation";
import ViewMore from "./ViewMore";
import { useFormik } from "formik";
import axiosInstance from "../../../../Services/axiosCommon";
import * as yup from 'yup';
import { useToast } from "../../../../Components/Others/ToastServices";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import EditIcon from "../../../../Components/Icons/Edit";
import UseProductDropDownNew from "../../../../Components/Hooks/useProductSearch";
import { FormikSelect } from "../../../../Components/Utils/Input";



const MainUserSettingsIndex = (id) => {
  const [open, setOpen] = useState(false)
  const toast = useToast();
  const {officeId} = useParams();

  const [creatNew,setCreateNew]= useState({
    userId:"",
    roleId:""
  })
  const [search, setSearch] = useState("");

  const { data: Item, setData } = UseProductDropDownNew(
    `/items/new-drop-down/${officeId}/branch`,
    search
  );

   const [error, setError] = useState("");
    const [productError, setProductError] = useState("");
  
  console.log(officeId,'offfff');
    const [items, setItems] = useState([]);
  const [isEditDivision, setIsEditDivision] = useState(false);
    const [isEditRole, setIsEditRole] = useState(false);
    const [isEditProject, setIsEditProject] = useState(false);
  const [isEditCommon, setIsEditCommon] = useState(false);

  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20);
  const { data, totalCount, getData } = UseGetData(
    page,
    pageCount,
    "/user/all-users"
  );
  const [viewMode, setViewMode] = useState("list");

  const [newItemData, setNewItemData] = useState({
      productId: "",
      quantity: "",
      product_unit: "",
      name:""
    });
  
  let header = [
    {
      label: "ID",
      width: "w-[5%]",
    },
    {
      label: "Name",
      width: "w-[20%]",
    },
    {
      label: "Email",
      width: "w-[15%]",
    },
    {
      label: "Phone",
      width: "w-[15%]",
    },
    {
      label: "Division",
      width: "w-[15%]",
    },
    {
      label: "Status",
      width: "w-[12%]",
    },
    {
      label: "Action",
      width: "w-[8%]",
    },
  ];

  // const user = [
  //   {
  //     name: "Lional Messi",
  //     division: "4.7",
  //     role: "Teacher",
  //     status: "active",
  //   },
  //   {
  //     name: "Cristiano Ronaldo",
  //     division: "4.7",
  //     role: "Student",
  //     status: "inactive",
  //   },
  //   {
  //     name: "Neymar JR",
  //     division: "4.7",
  //     role: "Working",
  //     status: "inactive",
  //   },
  //   {
  //     name: "Rohit Sharma",
  //     division: "4.7",
  //     role: "Teacher",
  //     status: "active",
  //   },
  // ]

  const handleAdd = () => {
    let hasError = false;

    if (!formik.values.name) {
      setProductError("Name is required");
      hasError = true;
    } else {
      setProductError("");
    }

    // if (!formik.values.product_unit) {
    //   setUnitError("Unit is required");
    //   hasError = true;
    // } else {
    //   setUnitError("");
    // }

    // if (!formik.values.quantity) {
    //   setQuantityError("Quantity is required");
    //   hasError = true;
    // } else {
    //   setQuantityError("");
    // }

    if (hasError) return;

    if (formik.values.name) {
      // const selectedProduct = Item.find(
      //   (i) => i.value === formik.values.productId
      // );
      const newItem = {
        name: formik.values.name,
        division: "",
        role: "",

        status: "inactive",

        // productName: sortedProList.find((i) => i.value === formik.values.productId),
        // quantity: formik.values.quantity,
        // // unit:selectedProduct.unit
        // product_unit: formik.values.product_unit,
      };
      setItems([...items, newItem]);

      setNewItemData({
        // productId: "",
        // quantity: "",
        // product_unit: "",
        name:"",
        // unit:""
      });
      // let updatedItems = Item.filter(
      //   (it) => it.value !== formik.values.productId
      // );
      // setData(updatedItems);
      // formik.values.productId = "";
      // formik.values.quantity = "";
      // formik.values.product_unit = "";
      formik.values.name = "";

      setError("");
    }
  };

  const handleQuantityChange = (e, index) => {
    const updatedQuantity = e?.target?.value;

    // Update the specific item's quantity
    const updatedItems = items.map((item, idx) => {
      if (idx === index) {
        return { ...item, role: updatedQuantity };
      }
      return item;
    });

    setItems(updatedItems); // Update the state with new quantity
  };

  const handleDeleteItem = (indexToDelete) => {
    const updatedItems = items.filter((_, index) => index !== indexToDelete);
    let ddUpdatedItem = items.find((_, i) => i === indexToDelete);
    setItems(updatedItems);
    let tempDd = ddUpdatedItem.name;
    setData([...Item, tempDd]);
    // localStorage.setItem("items", JSON.stringify(updatedItems));
  };


  const formik = useFormik({
    initialValues:creatNew,
    enableReinitialize:true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      name: yup.string().required('User is requred!'),
      roleId: yup.string().required('Role is requred!')
    }),
    onSubmit: async (value, { resetForm }) => {
      axiosInstance.post(`/user-role/`,value).then(res=>{
        if(res?.data?.status==true){
          // ActiveUser(value?.userId)
          resetForm()
          getData()
          useToast.open({
            type:"success",
            message:"Success",
            description: res.data?.msg || "Created Successfully."
          })
          setOpen(false)
        }else{
          toast.open({
            type:"error",
            message:"Error",
            description: res.data.error || res.data?.msg || res.data?.message  || "Network error."
          })
        }
      }).catch(err=>{
        console.error(err);
        toast.open({
          type:"error",
          message:"Error",
          description: err.response.data.error || err.response.data.message || err.response.data.msg || "Network error."
        })
      })
 }
  })

  useEffect(() => {
    getData();
    localStorage.setItem("viewMode", viewMode);
  }, [page, pageCount, viewMode]);

  function OnClose(){
    formik.resetForm() 
    setOpen(false)
  }

  return (
    <>
    <div className="w-full h-full px-4 py-2">
      <div className="w-full flex justify-between items-center">
        <Breadcrumb
          items={[
            {
              name: "Settings",
            },
            {
              name: "User",
            },
          ]}
        />
        <BackButton />
      </div>
      <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto  p-2 rounded-md">
        <div className=" w-full flex justify-between items-center">
             <p className='text-sm pl-3 font-semibold text-[#111537] text-left'>Users : {totalCount}</p>

          <div className="flex gap-2">
          <div className='flex gap-2'>
            {/* <div onClick={() => setViewMode("list")} className={viewMode === "list" ? "bg-baseColor-primary h-8 w-10 rounded-md flex justify-center items-center text-white" : "bg-white h-8 w-10 rounded-md flex justify-center items-center cursor-pointer"}><List/></div>
            <div onClick={() => setViewMode("card")} className={viewMode === "card" ? "bg-baseColor-primary h-8 w-10 rounded-md flex justify-center items-center text-white" : "bg-white h-8 w-10 rounded-md flex justify-center items-center cursor-pointer"}><Card/></div> */}
          </div>
          <CreateButton handleClick={()=>setOpen(true)} label="Convert" />

          <Link to={`/settings/${officeId}/user/create`}>
            <CreateButton label="User" />
          </Link>
          </div>
        </div>
      {viewMode === "list" ? (
        <DataTable
          headers={header}
          total={totalCount}
          pageIndex={page}
          setPageIndex={setPage}
          dataCount={pageCount}
          setDataCount={setPageCount}
          height="h-[calc(100vh-210px)]"
          bodyHeight="max-h-[calc(100vh-280px)]"
        //    bodyHeight="max-h-[calc(100vh-260px)]"
        // height="h-[calc(100vh-145px)]"
        >
          {data &&
            data.map((item, index) => (
              <tr
                className="odd:bg-white even:bg-slate-50 hover:text-baseColor-primary hover:shadow-md hover:scale-y-105"
                key={index}
              >
                <td className="py-3 px-[8px] text-center w-[5%]">
                  {[index+1] || "#"}
                </td>
                <td className="py-3 px-[8px] text-center w-[20%]">
                <Link className='hover:text-baseColor-primary text-mainColor-400'  to={`/settings/${officeId}/user/view/${item?.userId}`} state={{data:item}}>              
                 {item?.name || "#"}</Link>
 
                </td>
                <td className="py-3 px-[8px] text-center w-[15%]">
                  {item?.email || "#"}
                </td>
                <td className="py-3 px-[8px] text-center w-[15%]">
                  {item?.phone?.display || "#"}
                </td>
                <td className="py-3 px-[8px] text-center w-[15%]">
                  {item?.division || "#"}
                </td>
                <td className="py-3 px-[8px] text-center w-[12%]">
                  {item?.status==1?"Active":"Inactive" || "#"}
                </td>
                <td className="py-3 px-[8px] text-center w-[8%]">
                  {/* <MoreOptions
                    data={item}
                    fetcher={getData}
                    id={item?.userId|| ""}
                    removevalue={item?.name || "undefined"}
                    url={"/user/remove-user/"}
                    moduleName="User"
                    from={"/settings/user/"}
                    editLink={"/settings/user/edit/"}
                    viewLink={"/settings/user/view/"}
                   /> */}
                   <ViewMore  fetcher={getData} getData={getData}    removevalue={item?.name || "undefined"} data={item} id={item?.user?.id} editLink={`/settings/${officeId}/user/edit/`}  from={`/settings/${officeId}/user/`}/>
                </td>
              </tr>
            ))}
        </DataTable>
      ) : (
        <>
        <div className='w-full h-[calc(100vh-220px)] rounded-md bg-white p-3  relative overflow-y-scroll'>
      
          <div className='w-full flex justify-start flex-wrap md:gap-x-5 lg:gap-x-6 gap-y-6 '>
            {data && data.map((item, idx) => (
              <UserCard fetcher={getData} item={item} key={idx} />
            ))}
          </div>
        </div>
        <div className="w-full h-[20px] rounded-b-md bg-white">
          <Pagination
            total={totalCount}
            pageIndex={page}
            setPageIndex={setPage}
            dataCount={pageCount}
            setDataCount={setPageCount}
          />
        </div>
        </>
      )}
      </div>
    </div>
    
    {open && (
  <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
  <div className="animate-scale-in relative w-[90%] h-[95vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
    <button
      className="absolute top-2 right-2 text-white bg-red-600"
      onClick={() => setOpen(false)}
    >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      <p className=" text-sm font-semibold">Convert User</p>
      <form onSubmit={formik.handleSubmit}>
      <div className=" w-full h-full py-4 px-3 flex justify-start content-start gap-x-4 ">
      <FormikSelect
              type="text"
              label="Name"
              placeholder="Choose"
              // Options={userList}
              Options={[
                { value: "Dharshan", label: "Dharshan" },
                { value: "Shiko", label: "Shiko" },
                { value: "Alen", label: "Alen" },
                { value: "Sherin", label: "Sherin" },


              ]}
              formik={formik}
              name="name"
              width="w-full"
              isRequired={true}
            />

<button
                  onClick={handleAdd}
                  type="button"
                  className=" p-3 mt-10  text-center h-10 cursor-pointer bg-[#048178] border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                >
                  Add
                </button>
            {/* <FormikSelectTwo
              type="text"
              label="Role"
              placeholder="Choose"
              // Options={roleList}
              formik={formik}
              name="roleId"
              width="w-full"
              isRequired={true}
            /> */}
      </div>
      <div className="w-full bg-white overflow-y-scroll mt-5">
                {error && (
                  <p className="text-xs font-semibold text-red-500">{error}</p>
                )}
                <div className="w-full py-3  bg-[#048178] flex justify-between rounded-lg px-6">
                  {/* <p className="w-[5%]  text-left  text-white text-xs font-medium">
                    S.No{" "}
                  </p> */}

                  <p className=" w-[15%] text-left text-white text-xs font-medium">
                    Name
                  </p>
                  <p className=" w-[15%] text-center pl-4 text-white text-xs font-medium flex justify-center">
                    Role
                  </p>
                  <p className=" w-[15%] text-center  text-white text-xs font-medium flex justify-center">
                    Division
                  </p>

                  <p className=" w-[15%] text-center pl-4 text-white text-xs font-medium flex justify-center">
                    Project
                  </p>

                  <p className=" w-[15%] text-center  text-white text-xs font-medium flex justify-center">
                    Status
                  </p>

                  <p className=" w-[5%] text-right text-white text-xs font-medium flex justify-center">
                    Action
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditCommon((prv) => !prv);
                      }}
                    >
                                              {isEditCommon === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditCommon === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>
                </div>
                {items?.length > 0 ? (
                  <div className="h-[calc(100vh-300px)] overflow-y-scroll">
                    {items.map((List, index) => {
                      return (
                        <div
                          key={index}
                          className="w-full py-2 flex justify-between px-6  odd:bg-white even:bg-slate-50"
                        >
                          {/* <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] py-2.5">
                            {index + 1}
                          </p> */}
                          <p className=" w-[15%] text-left  text-xs font-medium text-[#111537] py-2.5">
                            {List?.name||""}
                          </p>
                          <p className=" w-[15%] text-center pl-4  text-xs font-medium text-[#111537] ">
                            {/* {List?.role} */}
                            {/* <Select
                              value={
                                Unit.find(
                                  (item) => item?.value == List.product_unit
                                ) || List.product_unit
                              }
                              options={isEditUnit ? Unit : []}
                              className="w-full"
                              onChange={(value) =>
                                handleProductUnitChange(value, index)
                              }
                              isDisabled={!isEditUnit}
                            /> */}
                            {/* <input
                              type="text"
                              className=" w-11/12 mx-auto outline-none text-center"
                              value={List?.role}
                              disabled={!isEditQua}
                              onChange={(e) => handleQuantityChange(e, index)}
                            /> */}

<FormikSelect
              type="text"
              // label="Name"
              placeholder="Choose"
              // Options={userList}
              Options={[
                { value: "A", label: "A" },
                { value: "B", label: "B" },
                { value: "C", label: "C" },

              ]}
              formik={formik}
              name="role"
              width="w-full"
              disabled={!isEditCommon}
                              onChange={(e) => handleQuantityChange(e, index)}
              // isRequired={true}
            />
                          </p>

                          <p className=" w-[15%] text-center   text-xs font-medium text-[#111537]">
                            {/* <FormikSelectTwo
                              type="text"
                              className=" w-11/12 mx-auto outline-none text-center"
                              value={List?.division}
                              disabled={!isEditQua}
                              onChange={(e) => handleQuantityChange(e, index)}
                            /> */}
                            <FormikSelect
              type="text"
              // label="Name"
              placeholder="Choose"
              // Options={userList}
              Options={[
                { value: "A", label: "A" },
                { value: "B", label: "B" },
                { value: "C", label: "C" },

              ]}
              formik={formik}
              name="division"
              width="w-full"
              // isRequired={true}
              disabled={!isEditCommon}
                              onChange={(e) => handleQuantityChange(e, index)}
            />
                          </p>
                          <p className=" w-[15%] text-center   text-xs font-medium text-[#111537]">
                          <FormikSelect
              type="text"
              // label="Name"
              placeholder="Choose"
              // Options={userList}
              Options={[
                { value: "A", label: "A" },
                { value: "B", label: "B" },
                { value: "C", label: "C" },

              ]}
              formik={formik}
              name="project"
              width="w-full"
              disabled={!isEditCommon}
                              onChange={(e) => handleQuantityChange(e, index)}
              // isRequired={true}
            />
                          </p>

                          <p className=" w-[8%] text-center  text-xs font-medium text-[#111537] ">
                            <FormikSelect
              type="text"
              // label="Name"
              placeholder="Choose"
              // Options={userList}
              Options={[
                { value: "active", label: "active" },
                { value: "in-active", label: "in-active" },

              ]}
              formik={formik}
              name="status"
              width="w-full"
              disabled={!isEditCommon}
                              onChange={(e) => handleQuantityChange(e, index)}
              // isRequired={true}
            />
                          </p>

                          <div className="w-[5%] text-right py-2.5">
                            <button
                              onClick={() => handleDeleteItem(index)}
                              type="button"
                              className="text-red-500 cursor-pointer  ml-4 border-none"
                            >
                              <DeleteButton color="red" width={14} height={14} />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="w-full text-center text-[#93949f]">
                    No Items here
                  </div>
                )}
              </div>
      <div className="w-full hidden md:block mx-auto">
              <div className="md:flex justify-end gap-4">
                <CancelButton
                  handleClick={OnClose}
                />
                <SubmitButton />
              </div>
            </div>
      </form>
    </div>
  </div>
)}
    
    </>
  );
};

export default MainUserSettingsIndex;
